<script lang="ts">
	/**
	 * Seal — small heart-with-spark mark at the end of a letter.
	 *
	 * Sits at the end of a signed close, charcoal on bone. The tooltip
	 * "Filed." is the quiet voice moment — Ekavi's audit-log discipline,
	 * stated as practice managers state it.
	 */

	import EkaviMark from './EkaviMark.svelte';

	interface Props {
		size?: number;
		label?: string;
	}

	let { size = 24, label = 'Filed.' }: Props = $props();
</script>

<span class="seal" title={label}>
	<EkaviMark {size} title={label} maskIdSuffix="seal" />
</span>

<style>
	.seal {
		display: inline-flex;
		line-height: 0;
		color: var(--ekavi-charcoal);
		opacity: 0.92;
	}
</style>
